module.exports = "https://static.zego.com/_next/static/images/FleetPrivateHire-a18eeab1df60609e58e0edfb2214861a.svg";